import React, { useEffect, useState } from 'react'
import { Card, CircularLoader, Modal } from '@st-operations/uikit/src/v2'

import { useEventFeedsContext } from '../../../context'
import { getTopDomains } from '_services/data-explorer'
import ListSelectionItem from '_components/list-selection-item'
import UrlListItem from '_components/url-list-item'

import './styles.scss'

const KeccTopDomainsModal = ({ field, word, isOpen, onClose }) => {
  const {
    data: { filters },
  } = useEventFeedsContext()

  const [wordTopDomains, setWordTopDomains] = useState()
  const [selectedTopDomain, setSelectedTopDomain] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setLoading(true)
    setWordTopDomains()
    setSelectedTopDomain()
    getTopDomains({
      filters: [...filters, { key: field, operator: 'in', value: [word] }],
    }).then(({ topDomains }) => {
      setWordTopDomains(topDomains)
      setSelectedTopDomain(topDomains?.[0])
      setLoading(false)
    })
  }, [filters, word])

  return (
    <Modal
      classes={{
        header: 'kecc-top-domains__modal-header',
        headerClose: 'kecc-top-domains__modal-header-close',
        content: 'kecc-top-domains__modal-content',
        childWrapper: 'kecc-top-domains__modal-child-wrapper',
        innerWrapper: 'kecc-top-domains__modal-inner-wrapper',
      }}
      size="large"
      isOpen={isOpen}
      onClose={onClose}
    >
      <div title={word}>
        <If condition={loading}>
          <div className="kecc-top-domains__loading">
            <CircularLoader />
          </div>
        </If>
        <If condition={!loading}>
          <Card noHover className="kecc-top-domains">
            <h3>Top Domains</h3>
            <div className="kecc-top-domains__content">
              <div className="kecc-top-domains__content-domains">
                <For each="topDomain" index="index" of={wordTopDomains || []}>
                  <ListSelectionItem
                    key={topDomain.domain}
                    number={index + 1}
                    onClick={() => setSelectedTopDomain(topDomain)}
                    selected={selectedTopDomain?.domain === topDomain.domain}
                  >
                    {topDomain.domain}
                  </ListSelectionItem>
                </For>
              </div>
              <div className="kecc-top-domains__content-urls">
                <For each="url" index="index" of={selectedTopDomain?.urls || []}>
                  <If condition={index !== 0}>
                    <div className="kecc-top-domains__content-urls-separator" />
                  </If>
                  <UrlListItem>{url.url}</UrlListItem>
                </For>
              </div>
            </div>
          </Card>
        </If>
      </div>
    </Modal>
  )
}

export default KeccTopDomainsModal
